import React, {useEffect, useState} from 'react';
import { styled } from '@mui/material/styles';
import { CardContent, Typography, Grid, IconButton, Tooltip, Button } from "@mui/material";
import ThreePIcon from '@mui/icons-material/ThreeP';
import EmailIcon from '@mui/icons-material/Email';
const PREFIX = 'ProjectTeamTable';

const classes = {
  label: `${PREFIX}-label`,
  nameWithMargin: `${PREFIX}-nameWithMargin`,
  iconButton: `${PREFIX}-iconButton`
};

const StyledCardContent = styled(CardContent)((
  {
    theme
  }
) => ({
  [`& .${classes.label}`]: {
    fontSize: '1rem',
    marginRight: theme.spacing(0.35),
    color: '#003865',
    [theme.breakpoints.between(800, 1775)]: {
      fontSize: '0.9rem',
    },
  },

  [`& .${classes.nameWithMargin}`]: {
    marginRight: theme.spacing(0), 
    textDecoration: 'none',
    wordWrap: 'none',
    color: 'black',
    '&:hover': {
      color: '#51a8ff',
    }
  },

  [`& .${classes.iconButton}`]: {
    color: 'grey',
    '&:hover': {
      color: '#51a8ff',
    },
  }
}));

const getFirstRecordWithEmail = (roles, roleName) => {
  const role = roles.find(r => r.role === roleName);
  return role ? { name: role.name, email: role.email } : { name: '--', email: '' };
};

const ProjectTeamTable = ({ teamData, selectedProject, reset }) => {
  const [localState, setLocalState] = useState({});

  const roles = teamData || [];

  useEffect(() => {
    if (reset) {
        setLocalState({});
    }
}, [reset]);

  const renderRole = (label, roleName) => {
    const { name, email } = getFirstRecordWithEmail(roles, roleName);
    const arconnectLink = email ? `https://arconnect.arco1.com/people/${email.split('@')[0]}` : '';
    return (
      <>
        <span className={classes.label}>{label}:</span>
        {email ? (
          <a href={arconnectLink} target="_blank" rel="noopener noreferrer" className={classes.nameWithMargin}>
            {name}
          </a>
        ) : (
          <span className={classes.nameWithMargin}>{name}</span>
        )}
        {email && (
          <>
            <Tooltip
                title={
                    <div className="warning-icon-tooltip-content">
                        <Typography sx={{fontSize: '1rem', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>{`Teams ${name}`}</Typography>
                    </div>
                }
            >
              <a className="teams-contact-button" href={`https://teams.microsoft.com/l/chat/0/0?users=${email}`} target="_blank" rel="noopener noreferrer">
                <IconButton size="small" className={classes.iconButton}>
                  <ThreePIcon className={classes.iconButton} sx={{ fontSize: "18px", paddingLeft: '0px' }}/>
                </IconButton>
              </a>
            </Tooltip>
          </>
        )}
      </>
    );
  };

  return (
    <StyledCardContent sx={{ padding: 0 }}>
      {Array.isArray(teamData) && teamData.length > 0 ? (
          <Grid container spacing={{ xs: 0 }}
            sx={{
              marginTop: '10px',
              marginBottom: '-30px',
              paddingRight: '0px',
              paddingLeft: '0px'
            }}>
            <Grid size={{ xs: 6 }}>
              <Typography className='project-team-typography'>
                {renderRole('PM', 'Project Manager')}
              </Typography>
              <Typography className='project-team-typography'>
                {renderRole('Super', 'Superintendent')}
              </Typography>
              <Typography className='project-team-typography'>
                {renderRole('PC', 'Project Coordinator')}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Typography className='project-team-typography'>
                {renderRole('Project Exec', 'Project Executive')}
              </Typography>
              <Typography className='project-team-typography'>
                {renderRole('Gen Super', 'General Superintendent')}
              </Typography>
              <Typography className='project-team-typography'>
                {renderRole('Accountant', 'Project Accountant')}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Typography variant="body1">--</Typography>
          </div>
        )}
    </StyledCardContent>
  );
};

export default ProjectTeamTable;